export enum ActiveLinkType {
  SelectKit = 'selectKit',
  ConfirmOrder = 'confirmOrder',
  PDPLink = '/product/MM/',
}

export enum ProductEnum {
  Milliplex = 'milliplex',
}

export enum MilliplexProperties {
  LoggedInUser = 'LoggedInUser',
  Species = 'species',
  Success = 'success',
  PredesignedPanel = 'Predesigned Panel',
  MAPmate = 'MAPmate',
}

export enum BreadcrumbsURL {
  PlatformSolution = '/products/protein-biology/immunoassay-platform-solutions',
  MilliplexLuminex = '/products/protein-biology/immunoassay-platform-solutions/milliplex-multiplex-assays-for-luminex-technology',
}
export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}
